// hooks/useOattSession.tsx
// Shared session state for OATT: persists customer and invoicing month across page navigation.

import { createContext, useContext, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

interface OattSessionState {
  customerId: number | null;
  setCustomerId: (id: number | null) => void;
  selectedDate: Dayjs;
  setSelectedDate: (date: Dayjs) => void;
}

const OattSessionContext = createContext<OattSessionState | null>(null);

export const OattSessionProvider = ({ children }: { children: React.ReactNode }) => {
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs().subtract(1, 'month'));

  return (
    <OattSessionContext.Provider value={{ customerId, setCustomerId, selectedDate, setSelectedDate }}>
      {children}
    </OattSessionContext.Provider>
  );
};

export function useOattSession(): OattSessionState {
  const ctx = useContext(OattSessionContext);
  if (!ctx) {
    throw new Error('useOattSession must be used within OattSessionProvider');
  }
  return ctx;
}
